import { DateTime } from "luxon";
import { padTime } from "../dateTimeFormatter";
import { getTimeZoneFromSwaStation } from "../timeZoneService";
import { IAM_CONTRACT, NON_CONTRACT, TWU_CONTRACT, WORKGROUP_MANAGER } from "../constants";
import { processRow, processHeader, downloadCSV } from "../csvUtils";
import { BID_TYPE } from "./bidConstants";

export function exportToCsv({ filename, rows, contract, seniorityListType, workgroup, bidType, station }) {
  var csvFile = "";
  for (var i = 0; i < rows.length; i++) {
    const currentRowToProcess = scrubBidGroupRowForExport({
      bidGroupRow: rows[i],
      contract,
      seniorityListType,
      workgroup,
      bidType,
      station,
    });
    if (i === 0) {
      csvFile += processHeader(currentRowToProcess);
    }
    csvFile += processRow(currentRowToProcess);
  }

  downloadCSV(csvFile, filename);
}

const scrubBidGroupRowForExport = ({ bidGroupRow, contract, seniorityListType, workgroup, bidType, station }) => {
  let scrubbedBidGroupRow = {
    "Bid Group Rank": bidGroupRow["rank"],
    Eligibility: !bidGroupRow["isRemoved"] ? (bidGroupRow["isEligible"] ? "Eligible" : "Ineligible") : "",
    Added: bidGroupRow["isManuallyAddedToBidGroup"] ? "Added" : "",
    Removed: bidGroupRow["isRemoved"] ? "Removed" : "",
    EID: bidGroupRow["eid"],
    Name: `${bidGroupRow["lastName"]}, ${bidGroupRow["shortName"]}`,
    Temp: bidGroupRow["isTemp"] && bidGroupRow["homeStation"] !== station ? "Temp" : "",
    PhoneNumber: bidGroupRow["phoneNumber"] ? bidGroupRow["phoneNumber"] : "-",
  };

  if (bidType === BID_TYPE.SHIFT) {
    scrubbedBidGroupRow["FT/PT"] = bidGroupRow["ftpt"];
  }

  if (bidType === BID_TYPE.FREEDAY) {
    scrubbedBidGroupRow["Standard/Relief"] = bidGroupRow["standardRelief"];
  }

  if (bidType === BID_TYPE.FTO) {
    scrubbedBidGroupRow["FTO Balance"] = bidGroupRow["balance"];
  }

  if (bidType === BID_TYPE.TWU_DAT_FTO) {
    scrubbedBidGroupRow["DAT Balance"] = bidGroupRow["datBalance"];
    scrubbedBidGroupRow["FTO Balance"] = bidGroupRow["ftoBalance"];
  }

  if (bidType === BID_TYPE.IAM_DAT) {
    scrubbedBidGroupRow["DAT Balance"] = bidGroupRow["datBalance"];
  }

  if (bidType === BID_TYPE.NC_PTO_FTO) {
    scrubbedBidGroupRow["PTO Balance"] = bidGroupRow["ptoBalance"];
    scrubbedBidGroupRow["FTO Balance"] = bidGroupRow["ftoBalance"];
  }

  if (bidType === BID_TYPE.NC_PTO_GOC_HOL) {
    scrubbedBidGroupRow["PTO Balance"] = bidGroupRow["ptoBalance"];
    scrubbedBidGroupRow["GOC-HOL Balance"] = bidGroupRow["gocHolBalance"];
  }

  if (contract === IAM_CONTRACT) {
    if (seniorityListType === "Classification") {
      scrubbedBidGroupRow["Classification Date"] = bidGroupRow["classificationDate"];
      scrubbedBidGroupRow["Contract Date"] = bidGroupRow["contractDate"];
      scrubbedBidGroupRow["Hire Date"] = bidGroupRow["hireDate"];
    } else if (seniorityListType === "Contract (Vacation)") {
      scrubbedBidGroupRow["Contract Date"] = bidGroupRow["contractDate"];
      scrubbedBidGroupRow["Classification Date"] = bidGroupRow["classificationDate"];
      scrubbedBidGroupRow["Hire Date"] = bidGroupRow["hireDate"];
    } else {
      alert("Unknown seniority list type: " + seniorityListType);
    }
  } else if (contract === TWU_CONTRACT) {
    scrubbedBidGroupRow["WN SLI Seniority Date"] = bidGroupRow["wnSliSeniorityDate"];
    scrubbedBidGroupRow["FL ATL Seniority Date"] = bidGroupRow["flAtlSeniorityDate"];
    scrubbedBidGroupRow["Dual Seniority Date"] = bidGroupRow["dualSeniorityDate"];
    scrubbedBidGroupRow["Hire Date"] = bidGroupRow["hireDate"];
  } else if (contract === NON_CONTRACT) {
    if (workgroup === WORKGROUP_MANAGER) {
      scrubbedBidGroupRow["Job Title"] = bidGroupRow["jobTitle"];
    }
    scrubbedBidGroupRow["Seniority Date"] = bidGroupRow["seniorityDate"];
    scrubbedBidGroupRow["Hire Date"] = bidGroupRow["hireDate"];
  } else {
    alert("Unknown contract type: " + contract);
  }
  return scrubbedBidGroupRow;
};

export const generateExportedFilename = ({ station, workgroup, fileType, bidType }) => {
  const date = DateTime.now().setZone(getTimeZoneFromSwaStation(station));
  const underScoredDate = `${padTime(date.month)}-${padTime(date.day)}-${date.year}_${padTime(date.hour)}${padTime(
    date.minute
  )}`;
  const underScoredWorkgroup = workgroup.split(" ").join("_");
  const underScoredBidType = bidType.split(" ").join("_");
  return `STARS_${station}_${underScoredWorkgroup}_${underScoredBidType}_Group_${underScoredDate}.${fileType}`;
};
